export default "__VITE_ASSET__4dQ3$xUl__"